<template>
  <v-card>
    <v-card-text>
      <h3>Comensales el Día de Familias</h3>
      Gente de fuera en la comida: {{ comida_dia_padres }}
      </br>
      Gente de fuera en la cena: {{ cena_dia_padres }}
      <br />
      <h4>Relacion Scouts/Comensales</h4>
      <v-data-table
          :headers="headers_relacion"
          :items="relacion"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.personas }}</td>
            <td>{{ props.item.comida }}</td>
            <td>{{ props.item.cena }}</td>
            <td>{{ props.item.idSecretaria }}</td>
          </template>
        </v-data-table>
      <h4>Intolerancias / Alergias/ Comentarios:</h4>
      <div
        v-for="(intolerancia, i) in comida_dia_padres_intolerancias"
        :key="i"
      >
        <li>{{ intolerancia }}</li>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: "diafamilias",
  data() {
    return {
      comida_dia_padres: 0,
      cena_dia_padres: 0,
      comida_dia_padres_intolerancias: [],
      relacion: [],
      headers_relacion:[
            { text: "Num de Scouts", align: "left", sortable: false, value: "personas" },
            { text: "Comida", align: "left", sortable: false, value: "comida" },
            { text: "Cena", align: "left", sortable: false, value: "cena" },
            { text: "Id secretaria", align: "left", sortable: false, value: "idSecretaria"}]
    }
  },
  created() {
    var out = this.$db
      .collection("forms")
      .doc("inscripciones")
      .collection("answers")
      .get().then((snapshot) => {
        snapshot.forEach((doc) => {
        //Contamos cuantos comen en campamento el dia de padres
        var recoger_comida_dia_padres = 0;
        if (doc.data() && doc.data().extre && doc.data().extre.lunch) {
          recoger_comida_dia_padres = parseInt(doc.data().extre.lunch);
        }
        if (recoger_comida_dia_padres > 0) {
          this.comida_dia_padres =
            this.comida_dia_padres + recoger_comida_dia_padres;
        }
        //Contamos cuantos cenan en campamento el dia de padres
        var recoger_cena_dia_padres = 0;
        if (doc.data() && doc.data().extre && doc.data().extre.dinner) {
          recoger_cena_dia_padres = parseInt(doc.data().extre.dinner);
        }
        if (recoger_cena_dia_padres > 0) {
          this.cena_dia_padres =
            this.cena_dia_padres + recoger_cena_dia_padres;
        }
        //Comentarios del dia de padres
        if (doc.data().extre && doc.data().extre.comentarios != null) {
          this.comida_dia_padres_intolerancias.push(
            doc.data().extre.comentarios
          );
        }

        //Relacion Scouts/Comensales
        if (doc.data().extre 
        && doc.data().extre.lunch != null 
        && doc.data().extre.dinner != null
        && (doc.data().extre.lunch > 0 || doc.data().extre.dinner > 0)) {
          this.relacion.push({
            personas: doc.data().peopleNumber,
            comida: doc.data().extre.lunch,
            cena: doc.data().extre.dinner,
            idSecretaria: doc.id,
          });
        }
      })});
  }
};
</script>

<style scoped>
</style>